<template>
  <div>
    <el-row>
      <el-button size="medium" @click="matchProject">新增匹配</el-button>
      <el-button size="medium" @click="unmatchProject(checkedArray)">批量解除匹配</el-button>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="项目名称" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="所属团餐公司" prop="TC_NAME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="unmatchProject([scope.row.ID])" type="text">解除匹配</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      creatNewVisible: false,
      rules: { NAME: [{ required: true, message: '请输入分拣组名称', trigger: 'blur' }] },
      id: this.$route.params.id,
      checkedArray: [],
    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    // 拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 21,
        GROUP_ID: this.id,
      };
      http.post(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    matchProject() {
      this.$router.push({ path: `/sortingGroupMatchProjrct/${this.id}`, params: { id: this.id } });
    },
    unmatchProject(arr) {
      this.$confirm(`您确定解除匹配${arr.length > 1 ? '选中的' : '该'}项目点吗?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          const params = {
            SERVICE_ID: '10049',
            OTYPE: 20,
            ID_LIST: arr,
          };
          http.post(params)
            .then((result) => {
              this.$message.show({ text: '解除成功', type: 'success' });
              this.queryTable();
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
        }).catch(() => {
          this.$message.show({ type: 'info', text: '取消操作' });
        });
    },
    handleSelectionChange(val) {
      this.checkedArray = val.map((item) => item.ID);
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/sortingGroupMatchedProjrct.vue